/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import React from "react";
import { FiSearch } from "react-icons/fi";

type Props = {
  isOpen: boolean;
  onClick: () => void;
};

const styles = {
  button: css({
    appearance: "none",
    background: "none",
    border: "none",
    borderRadius: 0,
    cursor: "pointer",
    marginLeft: 12,
    outline: 0,
    padding: 0,
    textAlign: "center",
    transition: "all 0.15s var(--transition)",
    svg: css({
      color: "var(--mutedTextColor)",
      display: "block",
      transition: "all 0.125s var(--transition)",
    }),
    "&:disabled": {
      backgroundColor: "var(--lighterTextColor)",
      boxShadow: "none",
      color: "var(--mutedTextColor)",
      cursor: "default",
    },
    "@media (min-width: 992px)": {
      display: "none",
    },
  }),
  buttonActive: css({
    svg: css({
      color: "var(--defaultBrandColor)",
    }),
  }),
};

export const SearchHandler: React.FC<Props> = ({ isOpen, onClick }) => (
  <button type="button" css={[styles.button, isOpen && styles.buttonActive]} onClick={onClick}>
    <FiSearch size={24} />
  </button>
);
